import { useMemo } from 'react'

import { normalizeStateExpression } from '../utils/joker'

/**
 * Hook that returns true when all specified state paths are defined (not undefined).
 */
export default function useReadyToFetch(
  waitForState: string[],
  state: unknown
): boolean {
  return useMemo(() => {
    if (!waitForState || waitForState.length === 0) return true

    return waitForState.every((attribute) => {
      const attrParts = normalizeStateExpression(attribute).split('.')
      let value = state

      for (const part of attrParts) {
        if (value === null || value === undefined || typeof value !== 'object')
          return false
        value = value[part as keyof typeof value]
      }

      return value !== undefined
    })
  }, [state, waitForState])
}
